import { applySanMove } from "@chessla/shared";
import { explainMove } from "@/features/board";
import type { PatternExample } from "./patterns.api";

export const requestPatternExplanation = async (example: PatternExample, signal: AbortSignal) => {
  const played = example.fenBefore && applySanMove(example.fenBefore, example.san);
  if (!played || !example.playerColor)
    throw new Error("The recorded position is unavailable. Open the game to inspect it.");
  const response = await explainMove(
    {
      requestId: crypto.randomUUID(),
      gameId: example.gameId,
      moveNumber: example.moveNumber,
      san: example.san,
      fenBefore: example.fenBefore!,
      fenAfter: played.fen,
      isBlunder: (example.centipawnLoss ?? 0) >= 200,
      isMistake: (example.centipawnLoss ?? 0) >= 100,
      centipawnLoss: example.centipawnLoss ?? 0,
      bestMoveSan: example.bestMoveSan ?? null,
      bestMoveFrom: example.bestMoveFrom ?? null,
      bestMoveTo: example.bestMoveTo ?? null,
      action: "fit_patterns",
      playerColor: example.playerColor,
    },
    signal,
  );
  if (!response.explanation.trim()) throw new Error("Nikola returned no explanation. Please retry.");
  return response;
};
